<template>
  <div class="bg-gray-800 rounded-t-none rounded-lg pb-2">
    <div class="px-3 py-3">Aplliquer le nouveau label aux contributions sélectionnées :</div>
    <button
      @click="handleAssociate()"
      class="flex p-3 bg-gray-700 font-light text-white text-base justify-center w-full focus:outline-none"
    >
      Oui
    </button>
    <button
      @click="$emit('closeMenu')"
      class="flex p-3 bg-gray-800 font-light text-white text-base justify-center w-full focus:outline-none"
    >
      Non
    </button>
  </div>
</template>

<script>
import { mapMutations, mapState, mapActions, mapGetters } from "vuex"

export default {
  props: {
    editedIndex: Number,
  },
  computed: {
    ...mapGetters("labels", ["getLabelColors"]),
    ...mapState({
      labels: (state) => state.labels.all,
    }),
  },
  methods: {
    ...mapActions("answers", ["associateLabelToSelectedAnswers"]),
    handleAssociate() {
      this.associateLabelToSelectedAnswers(this.labels[this.labels.length - 1])
      this.$emit("closeMenu")
    },
  },
}
</script>

<style></style>
